import { useCallback, useEffect, useRef, useState } from 'react'
import { useMenu } from '../../../context/MenuContext'
import { saveLogClube } from '../../../services/logClube';
import { formatMoney } from '../../../Utils/formatMoney'

import { ContainerList, CardContainer, CardList, Container } from './style'

export function Card({ 
  products, 
  title, 
  image, 
  searchTerm, 
  searchResults, 
  businessDatas,
}) {
  const [click, setClick] = useState(false);
  const [height, setHeight] = useState('0px')
  const nameBusiness = window.location.pathname.split('/')[2];

  const myRef = useRef(null);
  const heightRef = useRef(null)

  const { 
    handleSetItem, 
    handleSetImageModal,
    addAdditionalPriceToProduct,
    fetchAdditionalData
  } = useMenu();

  //console.log('PRODUCTS')
  //console.log(products)

  const handleClick = useCallback(() => {
    setClick(!click)
  
    setHeight(click === false ? `${heightRef.current.scrollHeight}px` : '0px')
  }, [click])

  const styleDefault = {
    backgroundImage: "linear-gradient(transparent 60%, rgba(0, 0, 0, 0.9) )",

  }

  useEffect(() => {
    const pixel = myRef.current.offsetTop - 150

    if(click === true){
      setTimeout(() => {
        window.scrollTo({ behavior: 'smooth', top: pixel })
      }, 200)
    }
  }, [click])

  return (
    <>
      {
        (searchTerm.length !== "" && searchTerm.trim() !== "") ?
          searchResults.map(item => (
            products.map((product, index) => (
              (product.name === item) ?
                <ContainerList key={product.idProduct}>
                  <CardList key={index} productImage={product.linkImage} >
                  {product.linkImage !== "" ?
                    <div 
                      className="image" 
                      onClick={() => { 
                        handleSetImageModal({ 
                          show: true, 
                          src: product.linkImage 
                        }) 
                      }} 
                    >
                    </div> : <></>
                  } 
                    <div className="text" onClick={() => {
                   
                      if(businessDatas.useOnlineOrder || product.isAssembledProduct){ 
                            handleSetItem({ 
                              code: product.idProduct, 
                              src: product.linkImage, 
                              name: product.name, 
                              cost: product.price, 
                              enable: product.enabled, 
                              assembled: product.isAssembledProduct, 
                              sizes: product.sizes, 
                              businessDatas, 
                              show: true
                            })
                            fetchAdditionalData(product.idProduct, nameBusiness)
                            addAdditionalPriceToProduct(product.price)
                            saveLogClube(localStorage.getItem('@Inoveclube:nameBusiness'),2,localStorage.getItem('@Inoveclube:token'))
                          }
                      }}>
                      <h3>{item}</h3>
                      <h4>{product.additionalInformation}</h4>
                      {
                        (product.oldPrice > 0) 
                          ? <span className="last-price">
                              { formatMoney(product.oldPrice) }
                            </span>
                          : <></>
                      }
                      <span>
                        {
                          product.price === 0 
                            ? 'Monte seu produto'
                            : formatMoney(product.price)
                        }
                      </span>
                    </div>
                  </CardList>
                </ContainerList> : <></>
            ))
          ))
          :
          <>
              <CardContainer onClick={() => handleClick(myRef)} ref={myRef} image={image} style={(image === "") ? styleDefault : { color: "white" }}>
                <h2>{title}</h2>
              </CardContainer>

              <Container height={height} ref={heightRef}>
                {products.map((product, index) => (
                  <ContainerList key={product.idProduct}>
                    <CardList key={index} productImage={product.linkImage} click={click}>
                      {product.linkImage !== "" ?
                        <div 
                          className="image" 
                          onClick={() => { 
                            handleSetImageModal({ 
                              show: true, 
                              src: product.linkImage 
                            }) 
                          }} 
                        >
                        </div> : <></>
                      }
                      <div className="text" 
                        onClick={() => {
                              if(businessDatas.useOnlineOrder || product.isAssembledProduct){ 
                                handleSetItem({ 
                                  code: product.idProduct, 
                                  src: product.linkImage, 
                                  name: product.name, 
                                  cost: product.price, 
                                  enable: product.enabled, 
                                  assembled: product.isAssembledProduct, 
                                  sizes: product.sizes, 
                                  businessDatas, 
                                  show: true
                                })
                                fetchAdditionalData(product.idProduct, nameBusiness)
                                addAdditionalPriceToProduct(product.price)
                                saveLogClube(localStorage.getItem('@Inoveclube:nameBusiness'),2,localStorage.getItem('@Inoveclube:token'))
                              }
                            }}
                        >
                          <h3>{product.name}</h3>
                          <h4>{product.additionalInformation}</h4>
                          {
                            (product.oldPrice > 0) 
                              ? <span className="last-price">
                                  { formatMoney(product.oldPrice) }
                                </span>
                              : <></>
                          }
                          <span>
                            {
                              product.price === 0 
                                ? 'Monte seu produto'
                                : formatMoney(product.price)
                            }
                          </span>
                      </div>
                    </CardList>
                  </ContainerList> 
                )
                )}
            </Container>
          </>
      }
    </>
  );
}
